import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { HttpAuthenticationService } from './http-authentication.service';
import { TokenService } from './token.service';
import { LocalUserService } from './local-user.service';
import { UserService } from './user.service';
import { AuthorizationGuardService } from './authorization-guard.service';
import { HttpAuthInterceptor } from './http.interceptor';

// Module descriptor
// Import this in your app.module

@NgModule({
	imports: [
		CommonModule
	],
	providers: [
		HttpAuthenticationService,
		TokenService,
		LocalUserService,
    UserService,
		AuthorizationGuardService,
		{
      provide: HTTP_INTERCEPTORS,
      useClass: HttpAuthInterceptor,
      multi: true,
    }
	]
})
export class AuthenticationModule {}


// WEBPACK FOOTER //
// ./src/app/authentication/authentication.module.ts